export default __webpack_public_path__ + "static/media/facebookLogo.15debe4c.png";